<script lang="ts">
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/App.vue";
import MainPage from "@/Components/MainPage.vue";

export default defineComponent({
    components: { MainPage },
    layout: AppLayout,
    props: {},
    emits: [],
    data: () => ({}),
    computed: {},
    methods: {},
});
</script>

<template>
    <MainPage title="Datenschutzerklärung" :gap="true">
        <div class="data-privacy-view flex flex--width flex--v flex--valign-s flex--gap-30">
            <span class="text text--size-27 text--semi-bold">Datenschutzerklärung</span>

            <div class="flex flex--v flex--valign-s flex--gap-15">
                <span class="text text--size-18 text--less-gap text--extra-bold">1. Datenschutz auf einen Blick</span>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Allgemeine Hinweise</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich
                        identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-12">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Datenerfassung auf dieser Website</span>

                    <div class="indent flex flex--v flex--valign-s flex--gap-8">
                        <span class="text text--size-16 text--less-gap text--semi-bold">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</span>
                        <span class="text text--size-16 text--less-gap text--regular">
                            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich
                            identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                        </span>
                    </div>

                    <div class="indent flex flex--v flex--valign-s flex--gap-8">
                        <span class="text text--size-16 text--less-gap text--semi-bold">Wie erfassen wir Ihre Daten?</span>
                        <span class="text text--size-16 text--less-gap text--regular">
                            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer
                            Einwilligung beim Besuch der Website durch unsere IT Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt
                            automatisch, sobald Sie diese Website betreten.
                        </span>
                    </div>

                    <div class="indent flex flex--v flex--valign-s flex--gap-8">
                        <span class="text text--size-16 text--less-gap text--semi-bold">Wofür nutzen wir Ihre Daten?</span>
                        <span class="text text--size-16 text--less-gap text--regular">
                            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
                            geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen verarbeitet.
                        </span>
                    </div>

                    <div class="indent flex flex--v flex--valign-s flex--gap-8">
                        <span class="text text--size-16 text--less-gap text--semi-bold">Welche Rechte haben Sie bezüglich Ihrer Daten?</span>
                        <span class="text text--size-16 text--less-gap text--regular">
                            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung
                            dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten
                            Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Hierzu sowie zu weiteren Fragen zum
                            Thema Datenschutz können Sie sich jederzeit an uns wenden.
                        </span>
                    </div>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Analyse-Tools und Tools von Drittanbietern</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Auf dieser Website werden keine Analyse- oder Marketing-Dienste eingesetzt. Es erfolgt keine Auswertung des Nutzerverhaltens durch Tools wie z. B. Google Analytics, Google Tag Manager, Matomo, Hotjar oder
                        vergleichbare Anwendungen. Es werden auch keine personenbezogenen Daten zu statistischen oder Werbezwecken an Dritte übermittelt. Die Erhebung technisch notwendiger Daten (z. B. IP-Adresse, Zeitstempel, Browsertyp)
                        erfolgt ausschließlich, um den sicheren und fehlerfreien Betrieb der Website zu gewährleisten (Art. 6 Abs. 1 lit. f DSGVO).
                    </span>
                </div>
            </div>

            <div class="flex flex--v flex--valign-s flex--gap-15">
                <span class="text text--size-18 text--less-gap text--extra-bold">2. Hosting</span>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Externes Hosting</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Unsere Website wird auf Servern der Stadt Oldenburg betrieben. Die Verarbeitung personenbezogener Daten erfolgt ausschließlich innerhalb der städtischen IT-Infrastruktur. Zu den dabei verarbeiteten Daten können
                        insbesondere IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe sowie sonstige über die Website generierte Informationen gehören.
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Der Betrieb der Server erfolgt im Rahmen der Wahrnehmung unserer Aufgaben als öffentliche Stelle (Art. 6 Abs. 1 lit. e DSGVO i. V. m. § 3 NDSG) sowie im Interesse einer sicheren, schnellen und zuverlässigen
                        Bereitstellung unseres Online-Angebots (Art. 6 Abs. 1 lit. f DSGVO). Sofern wir für bestimmte Vorgänge eine Einwilligung abfragen (z. B. für das Setzen technisch nicht notwendiger Cookies oder den Zugriff auf
                        Informationen im Endgerät gemäß § 25 Abs. 1 TDDDG), erfolgt die Verarbeitung ausschließlich auf Grundlage dieser Einwilligung. Die Einwilligung kann jederzeit widerrufen werden.
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Eine Weitergabe personenbezogener Daten an externe Hosting-Dienstleister findet nicht statt. Sämtliche Verarbeitungen erfolgen ausschließlich durch die Stadt Oldenburg innerhalb ihrer eigenen technischen
                        Infrastruktur.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Auftragsverarbeitung</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass
                        dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
                    </span>
                </div>
            </div>

            <div class="flex flex--v flex--valign-s flex--gap-15">
                <span class="text text--size-18 text--less-gap text--extra-bold">3. Allgemeine Hinweise und Pflichtinformationen</span>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Datenschutz</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
                        Datenschutzerklärung. Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende
                        Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht. Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei
                        der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Hinweis zur verantwortlichen Stelle</span>
                    <span class="text text--size-16 text--less-gap text--regular">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</span>
                    <span class="text text--size-16 text--less-gap text--regular text--height-18">
                        Stadt Oldenburg (Oldb)
                        <br />
                        Der Oberbürgermeister
                        <br />
                        26105 Oldenburg
                        <br />
                        E-Mail:
                        <a href="https://www.oldenburg.de/metanavigation/datenschutz.html" class="data-privacy-link">servicecenter[at]stadt-oldenburg.de</a>
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.)
                        entscheidet.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Speicherdauer</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes
                        Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten
                        haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach
                        Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung in die Übertragung personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1
                        lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich auf
                        Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten wir Ihre Daten auf
                        Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die
                        Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen
                        dieser Datenschutzerklärung informiert.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Datenschutzbeauftragter</span>
                    <span class="text text--size-16 text--less-gap text--regular">Wir haben einen Datenschutzbeauftragten benannt.</span>
                    <span class="text text--size-16 text--less-gap text--regular text--height-18">
                        Stadt Oldenburg (Oldb)
                        <br />
                        Der Oberbürgermeister
                        <br />
                        Behördliche Datenschutzbeauftragte
                        <br />
                        – persönlich –
                        <br />
                        26105 Oldenburg
                        <br />
                        E-Mail: datenschutzbeauftragte[at]stadt-oldenburg.de
                        <!-- <a href="https://www.oldenburg.de/metanavigation/datenschutz.html" class="data-privacy-link">servicecenter[at]stadt-oldenburg.de</a> -->
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Empfänger von personenbezogenen Daten</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei ist teilweise auch eine Übermittlung von personenbezogenen Daten an diese externen Stellen erforderlich. Wir geben
                        personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten an Steuerbehörden),
                        wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir
                        personenbezogene Daten unserer Kunden nur auf Grundlage eines gültigen Vertrags über Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über gemeinsame Verarbeitung geschlossen.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Widerruf Ihrer Einwilligung zur Datenverarbeitung</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
                        Datenverarbeitung bleibt vom Widerruf unberührt.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
                        PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER
                        DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN,
                        DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO). WERDEN IHRE
                        PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG
                        EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG
                        VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Beschwerderecht bei der zuständigen Aufsichtsbehörde</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des
                        mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Recht auf Datenübertragbarkeit</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen
                        zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Auskunft, Berichtigung und Löschung</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
                        Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Recht auf Einschränkung der Verarbeitung</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden
                        Fällen:
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der
                        Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung
                        verlangen. Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die
                        Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen
                        werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von
                        Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet
                        werden.
                    </span>
                </div>
            </div>

            <div class="flex flex--v flex--valign-s flex--gap-15">
                <span class="text text--size-18 text--less-gap text--extra-bold">4. Datenerfassung auf dieser Website</span>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Cookies</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Unsere Internetseiten verwenden sogenannte „Cookies“. Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies)
                        oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst
                        löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt. Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party- Cookies). Third-Party-Cookies ermöglichen die
                        Einbindung bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Webseitenfunktionen ohne diese nicht funktionieren würden (z. B. die Warenkorbfunktion oder die Anzeige von Videos).
                        Andere Cookies können zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet werden. Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs, zur Bereitstellung bestimmter, von Ihnen
                        erwünschter Funktionen (z. B. für die Warenkorbfunktion) oder zur Optimierung der Website (z. B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf Grundlage von Art. 6 Abs. 1
                        lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur technisch fehlerfreien und optimierten
                        Bereitstellung seiner Dienste.
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Sofern eine Einwilligung zur Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a
                        DSGVO und § 25 Abs. 1 TDDDG); die Einwilligung ist jederzeit widerrufbar. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die
                        Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser
                        Website eingeschränkt sein. Welche Cookies und Dienste auf dieser Website eingesetzt werden, können Sie dieser Datenschutzerklärung entnehmen.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Server-Log-Dateien</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                    </span>
                    <div class="indent flex flex--v flex--valign-s flex--gap-5">
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">Browsertyp und Browserversion</span>
                        </div>
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">verwendetes Betriebssystem</span>
                        </div>
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">Referrer URL</span>
                        </div>
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">Hostname des zugreifenden Rechners</span>
                        </div>
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">Uhrzeit der Serveranfrage</span>
                        </div>
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">IP-Adresse</span>
                        </div>
                    </div>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse
                        an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Kontaktformular</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von
                        Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich
                        ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6
                        Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach
                        abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Anfrage per E-Mail, Telefon oder Telefax</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
                        gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines
                        Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns
                        gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar. Die von Ihnen an uns per
                        Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener
                        Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.
                    </span>
                </div>
            </div>

            <div class="flex flex--v flex--valign-s flex--gap-15">
                <span class="text text--size-18 text--less-gap text--extra-bold">5. Matching-Funktion</span>
                <span class="text text--size-16 text--less-gap text--regular">
                    Unsere Website bietet eine interaktive Matching-Funktion, mit der Schülerinnen und Schüler ihre Interessen und Kompetenzen angeben können, um passende Praktikums- oder Ausbildungsangebote zu finden.
                </span>
                <span class="text text--size-16 text--less-gap text--regular">Dabei werden folgende Angaben verarbeitet:</span>

                <div class="indent flex flex--v flex--valign-s flex--gap-5">
                    <div class="flex flex--h flex--valign-c flex--gap-10">
                        <span class="text text--size-16 text--less-gap text--regular">•</span>
                        <span class="text text--size-16 text--less-gap text--regular">ausgewählte Interessen (z. B. Arbeitsumgebung, sozialer Kontakt, körperliche Tätigkeit, Arbeit mit dem Computer);</span>
                    </div>
                    <div class="flex flex--h flex--valign-c flex--gap-10">
                        <span class="text text--size-16 text--less-gap text--regular">•</span>
                        <span class="text text--size-16 text--less-gap text--regular">Einschätzung von bis zu 13 Kompetenzen über Regler- oder Auswahlfelder;</span>
                    </div>
                    <div class="flex flex--h flex--valign-c flex--gap-10">
                        <span class="text text--size-16 text--less-gap text--regular">•</span>
                        <span class="text text--size-16 text--less-gap text--regular">die resultierende prozentuale Übereinstimmung mit hinterlegten Anforderungsprofilen von Unternehmen.</span>
                    </div>
                </div>

                <span class="text text--size-16 text--less-gap text--regular">
                    Die Berechnung der Übereinstimmung erfolgt ausschließlich lokal innerhalb der aktuellen Browsersitzung. Eine Speicherung dieser Angaben auf dem Server oder eine Weitergabe an Dritte findet nicht statt. Nach dem Verlassen
                    oder Schließen der Website werden die Angaben automatisch verworfen. Die Berechnung der Übereinstimmung zwischen den eingegebenen Interessen/Kompetenzen und den Unternehmensprofilen erfolgt automatisiert anhand eines
                    einfachen gewichteten Vergleichsverfahrens.
                </span>
                <span class="text text--size-16 text--less-gap text--regular">
                    Der Algorithmus analysiert ausschließlich die von Ihnen freiwillig gemachten Angaben, verknüpft diese mit hinterlegten Anforderungsprofilen der Unternehmen und errechnet daraus eine prozentuale Übereinstimmung. Es findet
                    keine automatisierte Entscheidungsfindung im Sinne des Art. 22 DSGVO statt, da das Ergebnis keine rechtliche Wirkung entfaltet und keine Entscheidung über eine Person oder Bewerbung bewirkt.
                </span>
                <span class="text text--size-16 text--less-gap text--regular">Eine Identifizierung einzelner Nutzer*innen erfolgt nicht; die Berechnung findet ausschließlich lokal in Ihrem Browser statt.</span>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Zweck der Verarbeitung</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Bereitstellung einer digitalen Berufs- und Praktikumsorientierung, um Schülerinnen und Schülern eine anonyme und niederschwellige Möglichkeit zur Selbsteinschätzung und Orientierung zu bieten.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Rechtsgrundlage</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Art. 6 Abs. 1 lit. e DSGVO i. V. m. den einschlägigen kommunal- oder schulrechtlichen Bestimmungen (Wahrnehmung einer Aufgabe im öffentlichen Interesse); alternativ Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
                        an der Bereitstellung einer praxisorientierten Berufsorientierungsplattform). Es werden keine besonderen Kategorien personenbezogener Daten nach Art. 9 DSGVO verarbeitet.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Speicherdauer</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Es erfolgt keine dauerhafte Speicherung. Alle Angaben werden nur temporär verarbeitet und automatisch gelöscht, sobald die Browsersitzung beendet oder die Seite geschlossen wird.
                    </span>
                </div>
            </div>

            <div class="flex flex--v flex--valign-s flex--gap-15">
                <span class="text text--size-18 text--less-gap text--extra-bold">6. Registrierung für Unternehmen</span>
                <span class="text text--size-16 text--less-gap text--regular">
                    Unternehmen können auf unserer Website ein Profil anlegen, um Praktikums /Ausbildungsangebote zu veröffentlichen. Im Rahmen der Registrierung und Profilpflege verarbeiten wir die von Ihnen eingegebenen Daten.
                </span>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Verarbeitete Datenkategorien (je nach Eingabe)</span>

                    <div class="indent flex flex--v flex--valign-s flex--gap-5">
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">Unternehmensdaten: Name des Unternehmens, Beschreibung, Website, Adresse (Straße, Hausnummer, PLZ, Ort), ggf. Logo (Dateiupload).</span>
                        </div>
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">Angebotsdaten: Ausbildungsberuf, schulische Voraussetzungen, Bewerbungszeitraum/-fristen, Bewerbungsumfang, Besonderheiten.</span>
                        </div>
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">Ansprechpartner: Name, dienstliche E-Mail-Adresse, dienstliche Telefonnummer, ggf. Foto (Dateiupload).</span>
                        </div>
                    </div>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Zwecke der Verarbeitung</span>

                    <div class="indent flex flex--v flex--valign-s flex--gap-5">
                        <div class="flex flex--h flex--valign-c flex--gap-10">
                            <span class="text text--size-16 text--less-gap text--regular">•</span>
                            <span class="text text--size-16 text--less-gap text--regular">
                                Anlage und Verwaltung des Unternehmensprofils, Darstellung von Ausbildungs-/Praktikumsangeboten, Kontaktaufnahme und Rückfragen zur Veröffentlichung, Administration der Plattform und IT-Sicherheit.
                            </span>
                        </div>
                    </div>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Rechtsgrundlage</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Art. 6 Abs. 1 lit. e DSGVO i. V. m. den einschlägigen kommunal-/schulrechtlichen Vorschriften (Wahrnehmung einer Aufgabe im öffentlichen Interesse), alternativ Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
                        der Bereitstellung einer lokalen Berufsorientierungs- und Vermittlungsplattform).
                    </span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Sofern Sie freiwillig ein Foto/Logo hochladen, erfolgt die Verarbeitung zusätzlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), die Sie jederzeit mit Wirkung für die Zukunft widerrufen können.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Empfänger / Zugriff</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Intern befugte Stellen der Stadt (zuständiges Fachamt, zentrale IT/Administration). Eine Übermittlung an Dritte findet nicht statt; es erfolgt keine Drittlandübermittlung.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Öffentliche Sichtbarkeit</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Für die Portalsuche sichtbar sind typischerweise Unternehmensname, Beschreibung, Ort/Adresse, Website, Logo sowie Angebotsdaten (z. B. Ausbildungsberuf, Bewerbungszeitraum, Besonderheiten). Daten der Ansprechperson
                        (Name, dienstliche Kontaktdaten, Foto) werden ausschließlich zur Kommunikation im Rahmen der Plattform verwendet und nicht öffentlich angezeigt, sofern Sie diese nicht ausdrücklich in dafür vorgesehene öffentliche
                        Felder eintragen.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Speicherdauer / Löschung</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Die Daten werden bis auf Widerruf bzw. bis zur Löschung des Unternehmensprofils gespeichert. Nach Widerruf/Löschung werden die Daten aus der Live-Plattform entfernt; gesetzliche Aufbewahrungspflichten bleiben
                        unberührt.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Pflichtangaben / Freiwilligkeit</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Nur die als erforderlich gekennzeichneten Felder sind für die Profilanlage notwendig. Alle weiteren Angaben (z. B. Foto/Logo) sind freiwillig; ohne sie kann die Darstellung ggf. eingeschränkt sein.
                    </span>
                </div>
            </div>

            <div class="flex flex--v flex--valign-s flex--gap-15">
                <span class="text text--size-18 text--less-gap text--extra-bold">7. Eigene Dienste</span>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Umgang mit Bewerberdaten</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Wir bieten Ihnen die Möglichkeit, sich bei uns zu bewerben (z. B. per E-Mail, postalisch oder via Online- Bewerberformular). Im Folgenden informieren wir Sie über Umfang, Zweck und Verwendung Ihrer im Rahmen des
                        Bewerbungsprozesses erhobenen personenbezogenen Daten. Wir versichern, dass die Erhebung, Verarbeitung und Nutzung Ihrer Daten in Übereinstimmung mit geltendem Datenschutzrecht und allen weiteren gesetzlichen
                        Bestimmungen erfolgt und Ihre Daten streng vertraulich behandelt werden.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Umfang und Zweck der Datenerhebung</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Wenn Sie uns eine Bewerbung zukommen lassen, verarbeiten wir Ihre damit verbundenen personenbezogenen Daten (z. B. Kontakt- und Kommunikationsdaten, Bewerbungsunterlagen, Notizen im Rahmen von Bewerbungsgesprächen
                        etc.), soweit dies zur Entscheidung über die Begründung eines Beschäftigungsverhältnisses erforderlich ist. Rechtsgrundlage hierfür ist § 26 BDSG nach deutschem Recht (Anbahnung eines Beschäftigungsverhältnisses),
                        Art. 6 Abs. 1 lit. b DSGVO (allgemeine Vertragsanbahnung) und – sofern Sie eine Einwilligung erteilt haben – Art. 6 Abs. 1 lit. a DSGVO. Die Einwilligung ist jederzeit widerrufbar. Ihre personenbezogenen Daten werden
                        innerhalb unseres Unternehmens ausschließlich an Personen weitergegeben, die an der Bearbeitung Ihrer Bewerbung beteiligt sind. Sofern die Bewerbung erfolgreich ist, werden die von Ihnen eingereichten Daten auf
                        Grundlage von § 26 BDSG und Art. 6 Abs. 1 lit. b DSGVO zum Zwecke der Durchführung des Beschäftigungsverhältnisses in unseren Datenverarbeitungssystemen gespeichert.
                    </span>
                </div>

                <div class="indent flex flex--v flex--valign-s flex--gap-8">
                    <span class="text text--size-18 text--less-gap text--extra-bold">Aufbewahrungsdauer der Daten</span>
                    <span class="text text--size-16 text--less-gap text--regular">
                        Sofern wir Ihnen kein Stellenangebot machen können, Sie ein Stellenangebot ablehnen oder Ihre Bewerbung zurückziehen, behalten wir uns das Recht vor, die von Ihnen übermittelten Daten auf Grundlage unserer
                        berechtigten Interessen (Art. 6 Abs. 1 lit. f DSGVO) bis zu 6 Monate ab der Beendigung des Bewerbungsverfahrens (Ablehnung oder Zurückziehung der Bewerbung) bei uns aufzubewahren. Anschließend werden die Daten
                        gelöscht und die physischen Bewerbungsunterlagen vernichtet. Die Aufbewahrung dient insbesondere Nachweiszwecken im Falle eines Rechtsstreits. Sofern ersichtlich ist, dass die Daten nach Ablauf der 6-Monatsfrist
                        erforderlich sein werden (z. B. aufgrund eines drohenden oder anhängigen Rechtsstreits), findet eine Löschung erst statt, wenn der Zweck für die weitergehende Aufbewahrung entfällt. Eine längere Aufbewahrung kann
                        außerdem stattfinden, wenn Sie eine entsprechende Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) erteilt haben oder wenn gesetzliche Aufbewahrungspflichten der Löschung entgegenstehen.
                    </span>
                </div>
            </div>
        </div>
    </MainPage>

    <!-- <div class="old">
        <h2>Datenschutzerklärung</h2>
        <br />

        <p class="paragraph-Standard">
            <span class="text-T2">1. Datenschutz auf einen Blick</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Allgemeine Hinweise</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
            werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Datenerfassung auf dieser Website</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            <span class="text-T4">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</span>
            <span class="text-T4" />
        </p>

        <p class="paragraph-Standard">
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T4">Wie erfassen wir Ihre Daten?</span>
            <span class="text-T4" />
        </p>

        <p class="paragraph-Standard">
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim
            Besuch der Website durch unsere IT Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese
            Website betreten.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T4">Wofür nutzen wir Ihre Daten?</span>
            <span class="text-T4" />
        </p>

        <p class="paragraph-Standard">
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge geschlossen oder
            angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen verarbeitet.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T4">Welche Rechte haben Sie bezüglich Ihrer Daten?</span>
            <span class="text-T4" />
        </p>

        <p class="paragraph-Standard">
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu
            verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an
            uns wenden.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Analyse-Tools und Tools von Drittanbietern</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Auf dieser Website werden keine Analyse- oder Marketing-Dienste eingesetzt. Es erfolgt keine Auswertung des Nutzerverhaltens durch Tools wie z. B. Google Analytics, Google Tag Manager, Matomo, Hotjar oder vergleichbare
            Anwendungen. Es werden auch keine personenbezogenen Daten zu statistischen oder Werbezwecken an Dritte übermittelt. Die Erhebung technisch notwendiger Daten (z. B. IP-Adresse, Zeitstempel, Browsertyp) erfolgt ausschließlich, um
            den sicheren und fehlerfreien Betrieb der Website zu gewährleisten (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
        <p class="paragraph-Standard"> </p>
        <p class="paragraph-Standard">
            <span class="text-T2">2. Hosting</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Externes Hosting</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Unsere Website wird auf Servern der Stadt Oldenburg betrieben. Die Verarbeitung personenbezogener Daten erfolgt ausschließlich innerhalb der städtischen IT-Infrastruktur. Zu den dabei verarbeiteten Daten können insbesondere
            IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe sowie sonstige über die Website generierte Informationen gehören.
        </p>

        <p class="paragraph-Standard">
            Der Betrieb der Server erfolgt im Rahmen der Wahrnehmung unserer Aufgaben als öffentliche Stelle (Art. 6 Abs. 1 lit. e DSGVO i. V. m. § 3 NDSG) sowie im Interesse einer sicheren, schnellen und zuverlässigen Bereitstellung
            unseres Online-Angebots (Art. 6 Abs. 1 lit. f DSGVO). Sofern wir für bestimmte Vorgänge eine Einwilligung abfragen (z. B. für das Setzen technisch nicht notwendiger Cookies oder den Zugriff auf Informationen im Endgerät gemäß §
            25 Abs. 1 TDDDG), erfolgt die Verarbeitung ausschließlich auf Grundlage dieser Einwilligung. Die Einwilligung kann jederzeit widerrufen werden.
        </p>

        <p class="paragraph-Standard">
            Eine Weitergabe personenbezogener Daten an externe Hosting-Dienstleister findet nicht statt. Sämtliche Verarbeitungen erfolgen ausschließlich durch die Stadt Oldenburg innerhalb ihrer eigenen technischen Infrastruktur.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T1">Auftragsverarbeitung</span>
            <span class="text-T1" />
        </p>

        <p class="paragraph-Standard">
            Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser die
            personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">3. Allgemeine Hinweise und Pflichtinformationen</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Datenschutz</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
            Datenschutzerklärung. Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende
            Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht. Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der
            Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Hinweis zur verantwortlichen Stelle</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>

        <p class="paragraph-Standard">
            <span class="text-T5">Stadt Oldenburg (Oldb)</span>
            <span class="text-T6"><br /></span>
            <span class="text-T5">Der Oberbürgermeister</span>
            <span class="text-T6"><br /></span>
            <span class="text-T5">26105 Oldenburg</span>
            <span class="text-T6"><br /></span>
            <span class="text-T5">E-Mail: </span>
            <a href="https://www.oldenburg.de/metanavigation/datenschutz.html" class="text-Internet_20_link">
                <span class="text-Internet_20_link"><span class="text-T5">servicecenter[at]stadt-oldenburg.de</span></span>
            </a>
        </p>

        <p class="paragraph-Standard">
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Speicherdauer</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes
            Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z.
            B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs.
            1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung in die Übertragung personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie
            in die Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG. Die
            Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren
            verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten
            Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen dieser Datenschutzerklärung informiert.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Datenschutzbeauftragter</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">Wir haben einen Datenschutzbeauftragten benannt.</p>

        <p class="paragraph-P2">Stadt Oldenburg (Oldb)</p>

        <p class="paragraph-P2">Der Oberbürgermeister</p>

        <p class="paragraph-P2">Behördliche Datenschutzbeauftragte</p>

        <p class="paragraph-P2">– persönlich –</p>

        <p class="paragraph-P2">26105 Oldenburg</p>

        <p class="paragraph-P2">E-Mail: datenschutzbeauftragte[at]stadt-oldenburg.de</p>

        <p class="paragraph-P3">
            <span class="text-T2">Empfänger von personenbezogenen Daten</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei ist teilweise auch eine Übermittlung von personenbezogenen Daten an diese externen Stellen erforderlich. Wir geben
            personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten an Steuerbehörden), wenn wir ein
            berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir personenbezogene Daten unserer
            Kunden nur auf Grundlage eines gültigen Vertrags über Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über gemeinsame Verarbeitung geschlossen.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung
            bleibt vom Widerruf unberührt.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN
            DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH
            EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN
            ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO). WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN
            SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG
            STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Beschwerderecht bei der zuständigen Aufsichtsbehörde</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen
            Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Recht auf Datenübertragbarkeit</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen.
            Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Auskunft, Berichtigung und Löschung</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und
            ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Recht auf Einschränkung der Verarbeitung</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden Fällen:
        </p>

        <p class="paragraph-Standard">
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen. Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung verlangen. Wenn wir Ihre
            personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen. Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen
            Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
        </p>

        <p class="paragraph-Standard">
            Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von
            Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet werden.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">4. Datenerfassung auf dieser Website</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Cookies</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder
            dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder
            eine automatische Löschung durch Ihren Webbrowser erfolgt. Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party- Cookies). Third-Party-Cookies ermöglichen die Einbindung bestimmter
            Dienstleistungen von Drittunternehmen innerhalb von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
        </p>

        <p class="paragraph-Standard">
            Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Webseitenfunktionen ohne diese nicht funktionieren würden (z. B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies
            können zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet werden. Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs, zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z. B.
            für die Warenkorbfunktion) oder zur Optimierung der Website (z. B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine
            andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste.
        </p>

        <p class="paragraph-Standard">
            Sofern eine Einwilligung zur Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG); die Einwilligung ist jederzeit widerrufbar. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für
            bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein. Welche
            Cookies und Dienste auf dieser Website eingesetzt werden, können Sie dieser Datenschutzerklärung entnehmen.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Server-Log-Dateien</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
        <ul>
            <li>
                <p class="P1" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_10" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Browsertyp und Browserversion
                    <span class="odfLiEnd"></span>
                     
                </p>
            </li>
            <li>
                <p class="P1" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_10" style="display: block; float: left; min-width: 0.635cm">•</span>
                    verwendetes Betriebssystem
                    <span class="odfLiEnd"></span>
                     
                </p>
            </li>
            <li>
                <p class="P1" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_10" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Referrer URL
                    <span class="odfLiEnd"></span>
                     
                </p>
            </li>
            <li>
                <p class="P1" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_10" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Hostname des zugreifenden Rechners
                    <span class="odfLiEnd"></span>
                     
                </p>
            </li>
            <li>
                <p class="P1" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_10" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Uhrzeit der Serveranfrage
                    <span class="odfLiEnd"></span>
                     
                </p>
            </li>
            <li>
                <p class="P1" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_10" style="display: block; float: left; min-width: 0.635cm">•</span>
                    IP-Adresse
                    <span class="odfLiEnd"></span>
                     
                </p>
            </li>
        </ul>
        <p class="paragraph-Standard">
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der
            technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Kontaktformular</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei
            uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>

        <p class="paragraph-Standard">
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen
            übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern
            diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.
        </p>

        <p class="paragraph-Standard">
            Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach
            abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Anfrage per E-Mail, Telefon oder Telefax</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und
            verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder
            zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f
            DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar. Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns
            zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere
            gesetzliche Aufbewahrungsfristen – bleiben unberührt.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">5. Matching-Funktion</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">Unsere Website bietet eine interaktive Matching-Funktion, mit der Schülerinnen und Schüler ihre Interessen und Kompetenzen angeben können, um passende Praktikums- oder Ausbildungsangebote zu finden.</p>

        <p class="paragraph-Standard">Dabei werden folgende Angaben verarbeitet:</p>
        <ul>
            <li>
                <p class="P5" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_82" style="display: block; float: left; min-width: 0.635cm">•</span>
                    ausgewählte Interessen (z. B. Arbeitsumgebung, sozialer Kontakt, körperliche Tätigkeit, Arbeit mit dem Computer);
                    <span class="odfLiEnd" />
                     
                </p>
            </li>
            <li>
                <p class="P5" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_82" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Einschätzung von bis zu 13 Kompetenzen über Regler- oder Auswahlfelder;
                    <span class="odfLiEnd" />
                     
                </p>
            </li>
            <li>
                <p class="P4" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_82" style="display: block; float: left; min-width: 0.635cm">•</span>
                    die resultierende prozentuale Übereinstimmung mit hinterlegten Anforderungsprofilen von Unternehmen.
                    <span class="odfLiEnd" />
                     
                </p>
            </li>
        </ul>
        <p class="paragraph-Standard">
            Die Berechnung der Übereinstimmung erfolgt ausschließlich lokal innerhalb der aktuellen Browsersitzung. Eine Speicherung dieser Angaben auf dem Server oder eine Weitergabe an Dritte findet nicht statt. Nach dem Verlassen oder
            Schließen der Website werden die Angaben automatisch verworfen. Die Berechnung der Übereinstimmung zwischen den eingegebenen Interessen/Kompetenzen und den Unternehmensprofilen erfolgt automatisiert anhand eines einfachen
            gewichteten Vergleichsverfahrens.
        </p>

        <p class="paragraph-Standard">
            Der Algorithmus analysiert ausschließlich die von Ihnen freiwillig gemachten Angaben, verknüpft diese mit hinterlegten Anforderungsprofilen der Unternehmen und errechnet daraus eine prozentuale Übereinstimmung. Es findet keine
            automatisierte Entscheidungsfindung im Sinne des Art. 22 DSGVO statt, da das Ergebnis keine rechtliche Wirkung entfaltet und keine Entscheidung über eine Person oder Bewerbung bewirkt.
        </p>

        <p class="paragraph-Standard">Eine Identifizierung einzelner Nutzer*innen erfolgt nicht; die Berechnung findet ausschließlich lokal in Ihrem Browser statt.</p>

        <p class="paragraph-Standard">
            <span class="text-T2">Zweck der Verarbeitung</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">Bereitstellung einer digitalen Berufs- und Praktikumsorientierung, um Schülerinnen und Schülern eine anonyme und niederschwellige Möglichkeit zur Selbsteinschätzung und Orientierung zu bieten.</p>

        <p class="paragraph-Standard">
            <span class="text-T2">Rechtsgrundlage</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            <span class="text-T3">Art</span>
            . 6 Abs. 1 lit. e DSGVO i. V. m. den einschlägigen kommunal- oder schulrechtlichen Bestimmungen (Wahrnehmung einer Aufgabe im öffentlichen Interesse); alternativ Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
            Bereitstellung einer praxisorientierten Berufsorientierungsplattform). Es werden keine besonderen Kategorien personenbezogener Daten nach Art. 9 DSGVO verarbeitet.
        </p>

        <p class="paragraph-P3"><span class="text-T2">Speicherdauer</span></p>

        <p class="paragraph-Standard">Es erfolgt keine dauerhafte Speicherung. Alle Angaben werden nur temporär verarbeitet und automatisch gelöscht, sobald die Browsersitzung beendet oder die Seite geschlossen wird.</p>

        <p class="paragraph-Standard">
            <span class="text-T2">6. Registrierung für Unternehmen</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Unternehmen können auf unserer Website ein Profil anlegen, um Praktikums /Ausbildungsangebote zu veröffentlichen. Im Rahmen der Registrierung und Profilpflege verarbeiten wir die von Ihnen eingegebenen Daten.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Verarbeitete Datenkategorien (je nach Eingabe)</span>
            <span class="text-T2" />
        </p>
        <ul>
            <li>
                <p class="P7" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_19" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Unternehmensdaten: Name des Unternehmens, Beschreibung, Website, Adresse (Straße, Hausnummer, PLZ, Ort), ggf. Logo (Dateiupload).
                    <span class="odfLiEnd" />
                     
                </p>
            </li>
            <li>
                <p class="P7" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_19" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Angebotsdaten: Ausbildungsberuf, schulische Voraussetzungen, Bewerbungszeitraum/-fristen, Bewerbungsumfang, Besonderheiten.
                    <span class="odfLiEnd" />
                     
                </p>
            </li>
            <li>
                <p class="P6" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_19" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Ansprechpartner: Name, dienstliche E-Mail-Adresse, dienstliche Telefonnummer, ggf. Foto (Dateiupload).
                    <span class="odfLiEnd" />
                     
                </p>
            </li>
        </ul>
        <p class="paragraph-Standard">
            <span class="text-T2">Zwecke der Verarbeitung</span>
            <span class="text-T2" />
        </p>
        <ul>
            <li>
                <p class="P8" style="margin-left: 1.27cm">
                    <span class="ListLabel_20_28" style="display: block; float: left; min-width: 0.635cm">•</span>
                    Anlage und Verwaltung des Unternehmensprofils, Darstellung von Ausbildungs-/Praktikumsangeboten, Kontaktaufnahme und Rückfragen zur Veröffentlichung, Administration der Plattform und IT-Sicherheit.
                    <span class="odfLiEnd" />
                     
                </p>
            </li>
        </ul>
        <p class="paragraph-Standard">
            <span class="text-T2">Rechtsgrundlage</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Art. 6 Abs. 1 lit. e DSGVO i. V. m. den einschlägigen kommunal-/schulrechtlichen Vorschriften (Wahrnehmung einer Aufgabe im öffentlichen Interesse), alternativ Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
            Bereitstellung einer lokalen Berufsorientierungs- und Vermittlungsplattform).
        </p>

        <p class="paragraph-P2">
            Sofern Sie freiwillig ein Foto/Logo hochladen, erfolgt die Verarbeitung zusätzlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), die Sie jederzeit mit Wirkung für die Zukunft widerrufen können.
        </p>

        <p class="paragraph-P3">
            <span class="text-T2">Empfänger / Zugriff</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">Intern befugte Stellen der Stadt (zuständiges Fachamt, zentrale IT/Administration). Eine Übermittlung an Dritte findet nicht statt; es erfolgt keine Drittlandübermittlung.</p>

        <p class="paragraph-Standard">
            <span class="text-T2">Öffentliche Sichtbarkeit</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-P2">
            Für die Portalsuche sichtbar sind typischerweise Unternehmensname, Beschreibung, Ort/Adresse, Website, Logo sowie Angebotsdaten (z. B. Ausbildungsberuf, Bewerbungszeitraum, Besonderheiten). Daten der Ansprechperson (Name,
            dienstliche Kontaktdaten, Foto) werden ausschließlich zur Kommunikation im Rahmen der Plattform verwendet und nicht öffentlich angezeigt, sofern Sie diese nicht ausdrücklich in dafür vorgesehene öffentliche Felder eintragen.
        </p>

        <p class="paragraph-P3">
            <span class="text-T2">Speicherdauer / Löschung</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Die Daten werden bis auf Widerruf bzw. bis zur Löschung des Unternehmensprofils gespeichert. Nach Widerruf/Löschung werden die Daten aus der Live-Plattform entfernt; gesetzliche Aufbewahrungspflichten bleiben unberührt.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Pflichtangaben / Freiwilligkeit</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">Nur die als erforderlich gekennzeichneten Felder sind für die Profilanlage notwendig. Alle weiteren Angaben (z. B. Foto/Logo) sind freiwillig; ohne sie kann die Darstellung ggf. eingeschränkt sein.</p>

        <p class="paragraph-Standard">
            <span class="text-T2">7. Eigene Dienste</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Umgang mit Bewerberdaten</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Wir bieten Ihnen die Möglichkeit, sich bei uns zu bewerben (z. B. per E-Mail, postalisch oder via Online- Bewerberformular). Im Folgenden informieren wir Sie über Umfang, Zweck und Verwendung Ihrer im Rahmen des
            Bewerbungsprozesses erhobenen personenbezogenen Daten. Wir versichern, dass die Erhebung, Verarbeitung und Nutzung Ihrer Daten in Übereinstimmung mit geltendem Datenschutzrecht und allen weiteren gesetzlichen Bestimmungen
            erfolgt und Ihre Daten streng vertraulich behandelt werden.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Umfang und Zweck der Datenerhebung</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Wenn Sie uns eine Bewerbung zukommen lassen, verarbeiten wir Ihre damit verbundenen personenbezogenen Daten (z. B. Kontakt- und Kommunikationsdaten, Bewerbungsunterlagen, Notizen im Rahmen von Bewerbungsgesprächen etc.), soweit
            dies zur Entscheidung über die Begründung eines Beschäftigungsverhältnisses erforderlich ist. Rechtsgrundlage hierfür ist § 26 BDSG nach deutschem Recht (Anbahnung eines Beschäftigungsverhältnisses), Art. 6 Abs. 1 lit. b DSGVO
            (allgemeine Vertragsanbahnung) und – sofern Sie eine Einwilligung erteilt haben – Art. 6 Abs. 1 lit. a DSGVO. Die Einwilligung ist jederzeit widerrufbar. Ihre personenbezogenen Daten werden innerhalb unseres Unternehmens
            ausschließlich an Personen weitergegeben, die an der Bearbeitung Ihrer Bewerbung beteiligt sind. Sofern die Bewerbung erfolgreich ist, werden die von Ihnen eingereichten Daten auf Grundlage von § 26 BDSG und Art. 6 Abs. 1 lit. b
            DSGVO zum Zwecke der Durchführung des Beschäftigungsverhältnisses in unseren Datenverarbeitungssystemen gespeichert.
        </p>

        <p class="paragraph-Standard">
            <span class="text-T2">Aufbewahrungsdauer der Daten</span>
            <span class="text-T2" />
        </p>

        <p class="paragraph-Standard">
            Sofern wir Ihnen kein Stellenangebot machen können, Sie ein Stellenangebot ablehnen oder Ihre Bewerbung zurückziehen, behalten wir uns das Recht vor, die von Ihnen übermittelten Daten auf Grundlage unserer berechtigten
            Interessen (Art. 6 Abs. 1 lit. f DSGVO) bis zu 6 Monate ab der Beendigung des Bewerbungsverfahrens (Ablehnung oder Zurückziehung der Bewerbung) bei uns aufzubewahren. Anschließend werden die Daten gelöscht und die physischen
            Bewerbungsunterlagen vernichtet. Die Aufbewahrung dient insbesondere Nachweiszwecken im Falle eines Rechtsstreits. Sofern ersichtlich ist, dass die Daten nach Ablauf der 6-Monatsfrist erforderlich sein werden (z. B. aufgrund
            eines drohenden oder anhängigen Rechtsstreits), findet eine Löschung erst statt, wenn der Zweck für die weitergehende Aufbewahrung entfällt. Eine längere Aufbewahrung kann außerdem stattfinden, wenn Sie eine entsprechende
            Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) erteilt haben oder wenn gesetzliche Aufbewahrungspflichten der Löschung entgegenstehen.
        </p>
    </div> -->
</template>

<style lang="scss" scoped>
.data-privacy-view {
    .indent {
        padding-left: rem(30);
    }
    .data-privacy-link {
        color: $color-primary-a;
    }
}

// .old {
//     div {
//         padding: 20px;
//     }
//     table {
//         border-collapse: collapse;
//         border-spacing: 0;
//         empty-cells: show;
//     }
//     td,
//     th {
//         vertical-align: top;
//         font-size: 12pt;
//     }
//     h1,
//     h2,
//     h3,
//     h4,
//     h5,
//     h6 {
//         clear: both;
//     }
//     ol,
//     ul {
//         margin: 0;
//         padding: 0;
//     }
//     li {
//         list-style: none;
//         margin: 0;
//         padding: 0;
//     }
//     span.footnodeNumber {
//         padding-right: 1em;
//     }
//     span.annotation_style_by_filter {
//         font-size: 95%;
//         font-family: Arial;
//         background-color: #fff000;
//         margin: 0;
//         border: 0;
//         padding: 0;
//     }
//     span.heading_numbering {
//         margin-right: 0.8rem;
//     }
//     * {
//         margin: 0;
//     }
//     .paragraph-P1 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0.282cm;
//         margin-left: 1.27cm;
//         margin-top: 0cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-P2 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0cm;
//         margin-top: 0cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-P3 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0.282cm;
//         margin-top: 0.423cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-P4 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0.282cm;
//         margin-top: 0cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-P5 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0cm;
//         margin-top: 0cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-P6 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0.282cm;
//         margin-top: 0cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-P7 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0cm;
//         margin-top: 0cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-P8 {
//         font-size: 11pt;
//         line-height: 108%;
//         margin-bottom: 0.282cm;
//         margin-top: 0cm;
//         text-align: left !important;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//     }
//     .paragraph-Standard {
//         font-size: 11pt;
//         font-family: Aptos;
//         writing-mode: horizontal-tb;
//         direction: ltr;
//         margin-top: 0cm;
//         margin-bottom: 0.282cm;
//         line-height: 108%;
//         text-align: left !important;
//     }
//     .text-Internet_20_link {
//         color: #0000ff;
//         text-decoration: underline;
//     }
//     .text-T1 {
//         font-size: 12pt;
//         font-weight: bold;
//     }
//     .text-T2 {
//         font-size: 12pt;
//         font-weight: bold;
//     }
//     .text-T3 {
//         font-size: 12pt;
//     }
//     .text-T4 {
//         font-weight: bold;
//     }
// }
</style>
